import type { MealProgramSubscription } from '@/models/meal-program-subscription'
import type { ProductSubscription } from '@/models/product-subscription'
import type { ShopifyCustomer } from '@/types/shopify'

import { $customer, $subscriptions } from './stores'

export const setCustomerInfo = ({
  id,
  email,
  firstName,
  lastName,
  isSubscriber,
  emailHash,
  emailSha1Hash,
}: ShopifyCustomer) => {
  const simpleId = Number(id.split('/').pop())
  $customer.set({
    id,
    simpleId,
    email,
    firstName,
    lastName,
    isSubscriber,
    emailHash,
    emailSha1Hash,
  })
}

export const setSubscriptions = ({
  subscriptions,
  force,
}: {
  subscriptions: any[]
  force: boolean
}) => {
  const customer = $subscriptions.get()
  if (!customer) {
    return
  }

  const newSubscriptions: Array<MealProgramSubscription | ProductSubscription> =
    [...subscriptions]
  if (force) {
    $subscriptions.set(newSubscriptions)
  } else {
    const existingSubscriptions = $subscriptions.get()
    const filteredSubscriptions = newSubscriptions.filter((subscription) => {
      return !existingSubscriptions.some(
        (existingSubscription) => existingSubscription.id === subscription.id,
      )
    })
    $subscriptions.set([...existingSubscriptions, ...filteredSubscriptions])
  }
}
